<template>
  <span class="version-badge caption-s"> v{{ version }} </span>
</template>

<script>
import packageJson from "../../../package.json";

export default {
  name: "VersionBadge",

  computed: {
    version() {
      return packageJson.version;
    },
  },
};
</script>

<style lang="scss" scoped>
.version-badge {
  display: inline-flex;
  align-items: center;
  margin-top: 1px;
  font-size: var(--typography-font-size-fs-100);
  padding: 2px 4px;
  border-radius: var(--radius-rd-1000, 100px);
  background: var(--color-surface-primary-light-1);
  color: var(--color-text-primary-default);
  font-weight: var(--typography-font-weight-fw-600);
}
</style>
